import { css } from '@emotion/css';

//!important required to override the styles of pasted content
export const quoteBlockStyles = css`
  * {
    color: var(--text-primary) !important;
    background: transparent !important;
  }

  &.blockquote--placeholder::before {
    font-family: 'Charter', var(--font-primary), serif;
    font-size: 2rem;
    line-height: 1.6;
    font-style: italic;
    font-weight: 700;
    letter-spacing: -0.003em;
    padding-inline-start: 1.8rem;
  }
`;

export const quoteTextStyles = css`
  font-family: 'Charter', var(--font-castoro), var(--font-primary), serif;
  font-size: 2rem;
  line-height: 1.6;
  font-style: italic;
  font-weight: 700;
  letter-spacing: -0.003em;
`;
